// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/placements--jsm-sequoia/jira-navbar-assets-app-section';

import { MessageFrontend as createMessageFrontendJsmAssetsPremiumTrialItem } from '@post-office/message-template--jsm-assets-premium-trial-item/placements/in-app-v2/jira-navbar-assets-app-section';

import { withI18n } from './i18n';

import { type DefaultMessagesResponse } from '@post-office/placement-common-v2';

import { type PlacementRendererStage } from '@post-office/placement-common-v2/create-placement/types';

import { type ComponentType } from 'react';

const messageFrontends = [
createMessageFrontendJsmAssetsPremiumTrialItem({messageTemplateId: 'jsm-assets-premium-trial-item'}),
]

export const RawPlacement: PlacementRendererStage<{
    preloadedInitialData?: DefaultMessagesResponse | undefined;
    onMessageCountChange?: (numberOfMessages: number) => void;
    onItemClick?: () => void;
    onItemViewed?: () => void;
}> = PlacementFrontend.createPlacementFrontendComponent({
				messageTemplates: messageFrontends
			});

export const Placement: ComponentType<{
    preloadedInitialData?: DefaultMessagesResponse | undefined;
    onMessageCountChange?: (numberOfMessages: number) => void;
    onItemClick?: () => void;
    onItemViewed?: () => void;
}> = withI18n(RawPlacement)

export const SSRPlacement: PlacementRendererStage<{
    preloadedInitialData?: DefaultMessagesResponse | undefined;
    onMessageCountChange?: (numberOfMessages: number) => void;
    onItemClick?: () => void;
    onItemViewed?: () => void;
}> = RawPlacement
